<ng-template #header>
    <shared-vcard-for-order [orderId]="modalData.orderId" [showOrderId]="false" [preTitle]="preTitle"
        [description]="headerDescription">
        {{title$ | async}}
    </shared-vcard-for-order>
</ng-template>

<ng-template #footer>
    <shared-modal-item-actions [twoColumnsAlign]="twoColumnsAlign" [twoColumnsAdjust]="twoColumnsAdjust"
        [twoColumnsMarginBottom]="twoColumnsMarginBottom" [quantity]="1" [isQuantityVisible]="false"
        [buttonLabel]="buttonLabel" [disabled]="(reorderIsValid$ | async) === false"
        [buttonPrice]="reorderTotalValue$ | async" (onClick)="handleAddToBag($event)">
    </shared-modal-item-actions>
</ng-template>

<shared-modal-type-dynamic-height (onScrollInit)="handleScrollInit($event)" (onScrollY)="handleScrollY($event)"
    [dimmedBg]="dimmedBg" [shadow]="shadow" [footer]="footer" [size]="size" [header]="header" [minHeight]="minHeight"
    [modalData]="modalData" [center]="true" [fullPaddings]="fullPaddings" (onCloseClick)="handleCloseClick($event)"
    class="modal-view-for-reorders">

    <shared-reorder-wizzard [orderId]="modalData.orderId"></shared-reorder-wizzard>

</shared-modal-type-dynamic-height>